export type TAllSettled<T, U> = IAllSettledFulfilled<T> | IAllSettledRejected<U>;

export interface IAllSettledFulfilled<T> {
  status: 'fulfilled';
  value: T;
}

export interface IAllSettledRejected<T> {
  status: 'rejected';
  reason: T;
}

// TODO: delete this when edge supports Promise.allSettled

abstract class PromisesUtil {
  static isFullfilled<T, U>(promise: TAllSettled<T, U>): promise is IAllSettledFulfilled<T> {
    return promise.status === 'fulfilled';
  }

  static isRejected<T, U>(promise: TAllSettled<T, U>): promise is IAllSettledRejected<U> {
    return promise.status === 'rejected';
  }

  static allSettled<T, U>(promises: Promise<T>[]): Promise<TAllSettled<T, U>[]> {
    const wrapped = promises.map((promise) => {
      return promise.then(
        (value: T): IAllSettledFulfilled<T> => {
          return { status: 'fulfilled', value: value };
        },
        (errors: U): IAllSettledRejected<U> => {
          return { status: 'rejected', reason: errors };
        }
      );
    });

    return Promise.all(wrapped);
  }
}

export default PromisesUtil;
